import {
  isUgcDeliverableFormat,
  type BriefDeliverable,
  type UgcDeliverableFormat,
  type UgcMaxDurationSeconds,
} from '@fluenceur/types';

export interface UgcDeliverablePreset {
  /** Stable key for the add menu and the i18n label lookup. */
  key: 'ugcVideo' | 'ugcVideo4x5' | 'ugcPhoto';
  format: UgcDeliverableFormat;
  /** The length a new deliverable starts with; a photo has none. */
  maxDurationSeconds: UgcMaxDurationSeconds | null;
}

/**
 * The three formats a UGC brief asks for. The ratio is implied by the format
 * (video 9:16, video 4:5 for the feed, photo 4:5) and never stored; a video of
 * either ratio starts capped at 30 s, the default a new UGC brief ships with.
 */
export const UGC_DELIVERABLE_PRESETS: UgcDeliverablePreset[] = [
  { key: 'ugcVideo', format: 'ugc_video', maxDurationSeconds: 30 },
  { key: 'ugcVideo4x5', format: 'ugc_video_4x5', maxDurationSeconds: 30 },
  { key: 'ugcPhoto', format: 'ugc_photo', maxDurationSeconds: null },
];

/** The preset of a UGC deliverable, or undefined for a platform deliverable. */
export const ugcPresetForDeliverable = (
  deliverable: Pick<BriefDeliverable, 'format'>
): UgcDeliverablePreset | undefined =>
  isUgcDeliverableFormat(deliverable.format)
    ? UGC_DELIVERABLE_PRESETS.find((preset) => preset.format === deliverable.format)
    : undefined;

/** A fresh UGC deliverable: no platform, quantity 1. */
export const ugcDeliverableFromPreset = (preset: UgcDeliverablePreset): BriefDeliverable => ({
  id: crypto.randomUUID(),
  platform: null,
  format: preset.format,
  maxDurationSeconds: preset.maxDurationSeconds,
  quantity: 1,
});
